import React, { PureComponent } from 'react';
import { GenericSimpleButton, GenericModal, GenericModalButton } from 'com-gyf-webcore-userinterfacecomponents';
import { Link, Redirect } from "react-router-dom";
import 'rc-dialog/assets/bootstrap.css';

class ButtonsAdd extends PureComponent {

    constructor( props ) {
        super( props );
        this.saveClient = this.saveClient.bind(this);

    }
    saveClient(){ 
        const CantidadDeIntegrantes= this.props.solicitudCuenta.cuentasAdicionales.length +1
        let usoCajeros = null;
        if(!this.props.tarjetas.esCuentaExistente && this.props.tarjetas.administradora.Id == 1){
            usoCajeros = this.props.tarjetas.solicitudCuenta.GET_PRODUCTO_VISA_PRODUCTO_ID.UsoATM
        }
        
        const nuevoCliente={
            Nombre: this.props.tarjetas.administradora.Id == 1 ? this.props.data.nombreAdicional : this.props.tarjetas.clienteTarjeta.NOMBRE,
            Apellido: this.props.tarjetas.administradora.Id == 1 ? this.props.data.apellidoAdicional : this.props.tarjetas.clienteTarjeta.APELLIDO,
            PorcentajeEmision: this.props.data.porcEmision,
            CuotasEmision: this.props.data.cuotasEmision,
            denominacionCuartaLinea:this.props.data.denominacionCuartaLinea,
            CodigoDistribucionId: this.props.data.SelectCodigoDistribucionClienteAdicional,
            HabilitacionCajeroId: this.props.data.SelectHabilitacionCajeroAdicional,
            LimiteDeCompra: ((this.props.data.SeleccionModeloDistribucionLimitesClienteAdicional && this.props.tarjetas.administradora.Id==1)|| this.props.tarjetas.administradora.Id==2 )  ? this.props.data.LimiteDeCompraClienteAdicionalSeleccionado : "",
            LimiteDeCEC: this.props.data.SeleccionModeloDistribucionLimitesClienteAdicional ? this.props.data.LimiteDeCompraEnCuotasClienteAdicionalSeleccionado: "",
            LimiteDeAdelantos: this.props.data.SeleccionModeloDistribucionLimitesClienteAdicional ? this.props.data.LimiteDeAdelantosClienteAdicionalSeleccionado: "",
            idAdicional: this.props.data.idAdicional == 0 ? CantidadDeIntegrantes: this.props.data.idAdicional,
            LimitePorTransaccion: this.props.data.LimitePorTransaccionAdicionalSeleccionado,
            seleccionaTarjetaTemporal: this.props.data.seleccionaTarjetaTemporal,
            vigenciaTemporalId: this.props.data.vigenciaTemporalId,
            SeleccionLimiteTransaccionClienteAdicional: this.props.data.SeleccionLimiteTransaccionClienteAdicional,
            codigoSectorCentroDeCostos: this.props.data.codigoSectorCentroDeCostos,
            codigoAreaCentroDeCostos: this.props.data.codigoAreaCentroDeCostos,
            SeleccionModeloDistribucionLimitesClienteAdicional:this.props.data.SeleccionModeloDistribucionLimitesClienteAdicional,
            ClienteTarjetas: this.props.tarjetas.clienteTarjeta,
            usoCajerosConCargo: usoCajeros ? usoCajeros : (this.props.tarjetas.solicitudCuenta.GET_ATLAS_PARAMETRO_GENERAL.SINOREDBANELCO && this.props.tarjetas.administradora.Id == 1) ? ((this.props.data.usoCajerosConCargo == true || this.props.data.usoCajerosConCargo == "CC") ? "CC":"SC") : null,
            IdAdicional:this.props.data.IdAdicional,//ESTE CAMPO Y LOS DOS SIGUIENTES NO SERÁN UNDEFINED ÚNICAMENTE EN MODIFICACIONES
            TarjetaCreditoCabalId:this.props.data.TarjetaCreditoCabalId,
            TarjetaCreditoVisaId:this.props.data.TarjetaCreditoVisaId,
        }
        // this.props.GuardarClienteAdicional(nuevoCliente)
        this.props.validate(nuevoCliente);
        //this.props.confirmarClienteTarjeta(false);
    }
   
    
    render() {

        let saveButton = <GenericSimpleButton  onClick={this.saveClient} buttonType="button" text="Aceptar" buttonClass="btn btn-cta" />
        let cancelButton = <GenericSimpleButton onClick={()=>this.props.cancelarAdicional(this.props.tarjetas.solicitudCuenta)} buttonType="button" text="Cancelar" buttonClass="btn btn-secondary" />
        return (
            <div className="row top-separator-md">  
                <div className="col-md-6"></div>
                <div className="col-md-6">
                    <div className="row">
                        <div className="col-md-12">
                            <div style={{ float: "right" }}>
                                {saveButton}
                                <div style={{ marginLeft: "29px", display: "inline-block" }}>
                                    {cancelButton}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row bottom-separator-xs"></div>
            </div>
            
        )
    }
}

export default ButtonsAdd;